(function(){
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('rb-in'); e.target.classList.remove('rb-in-wait'); io.unobserve(e.target); } });
  }, {threshold: .1, rootMargin: '0px 0px -40px 0px'});
  function scan(root){
    var cards = (root || document).querySelectorAll('product-card.product-card:not([data-rb])');
    cards.forEach(function(c, i){
      c.setAttribute('data-rb', '1');
      var r = c.getBoundingClientRect();
      if (r.top < innerHeight) return;
      c.style.setProperty('--rb-d', (i % 4) * 90 + 'ms');
      c.classList.add('rb-in-wait'); io.observe(c);
    });
  }
  scan();
  new MutationObserver(function(){ scan(); }).observe(document.body, {childList: true, subtree: true});
})();

/* Adaugă în coș fără schimbarea paginii: deschide coșul lateral */
document.addEventListener('click', async function(e){
  var b = e.target.closest('.rbf-add[data-vid]'); if (!b) return;
  if (!document.querySelector('cart-drawer')) return;
  e.preventDefault(); b.classList.add('is-loading'); var txt = b.textContent; b.textContent = 'Se adaugă…';
  try {
    var sections = []; document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {bubbles: true, detail: {sections: sections}}));
    var r = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items: [{id: +b.dataset.vid, quantity: 1}], sections: sections.join(','), sections_url: location.pathname})});
    var j = await r.json(); if (!r.ok) throw new Error(j.description || 'Eroare');
    var cart = await (await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')).json(); cart.sections = j.sections;
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles: true, detail: {baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart}}));
    b.textContent = 'Adăugat ✓'; setTimeout(function(){ b.textContent = txt; }, 1800);
  } catch (err) { b.textContent = txt; alert(err.message || 'Produsul nu a putut fi adăugat în coș.'); }
  b.classList.remove('is-loading');
});


/* galerie card: săgeți + puncte */
document.addEventListener('click', function(e){
  var a = e.target.closest('.rbf-ar'); if (!a) return;
  e.preventDefault(); var m = a.parentNode.querySelector('.rbf-m');
  m.scrollBy({left: (a.classList.contains('rbf-nx') ? 1 : -1) * m.clientWidth});
});
document.addEventListener('scroll', function(e){
  var m = e.target; if (!m.classList || !m.classList.contains('rbf-m')) return;
  var d = m.parentNode.querySelector('.rbf-dots'); if (!d) return;
  var i = Math.round(m.scrollLeft / m.clientWidth);
  d.querySelectorAll('i').forEach(function(x, k){ x.classList.toggle('on', k === i); });
}, true);
/* carusel „Cele mai vândute” */
document.addEventListener('click', function(e){
  var b = e.target.closest('.rh-car-b'); if (!b) return;
  var g = b.parentNode.querySelector('.rbf-grid'); var c = g.querySelector('.rbf-c');
  g.scrollBy({left: (b.classList.contains('rh-car-n') ? 1 : -1) * (c ? c.offsetWidth : g.clientWidth)});
});
/* mărimi pe card: se schimbă pe loc, fără coș și fără schimbarea paginii */
(function(){
  var fm = function(c){ return (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' lei'; };
  document.addEventListener('click', async function(e){
    var a = e.target.closest('.rbf-sz a'); if (!a) return;
    e.preventDefault(); if (a.classList.contains('on')) return;
    var card = a.closest('.rbf-c'); card.classList.add('is-loading');
    try {
      var d;
      if (a.dataset.vid) { d = {vid: +a.dataset.vid, price: +a.dataset.p, cmp: +a.dataset.c || 0, imgs: JSON.parse(a.dataset.imgs || '[]'), title: a.dataset.t, url: a.href, avail: true}; }
      else {
        var r = await (await fetch('/products/' + a.dataset.h + '.js')).json();
        var v = r.variants.find(function(x){ return x.available; }) || r.variants[0];
        d = {vid: v.id, price: v.price, cmp: v.compare_at_price || 0, imgs: r.images.slice(0, 6), title: r.title, url: r.url, avail: r.available};
      }
      var pk = +(card.dataset.pk || card.dataset.keep) || 100, op = d.price, np = Math.round(d.price * pk / 100);
      if (d.cmp > d.price) { op = d.cmp; np = d.price; }
      var disc = np < op, pc = Math.round(100 - np * 100 / op);
      card.querySelector('.rbf-p').innerHTML = disc ? '<b class="rbf-red">' + fm(np) + '</b><s>' + fm(op) + '</s>' : '<b>' + fm(np) + '</b>';
      var off = card.querySelector('.rbf-off'); if (off && !card.dataset.code) { off.hidden = !disc; off.textContent = '−' + pc + '%'; }
      var rp = card.querySelector('.rcx-p'); if (rp) rp.textContent = fm(Math.round(np * .9));
      var med = card.querySelector('.rbf-med b'); if (med && disc) med.textContent = '−' + pc + '%';
      card.querySelectorAll('.rbf-t').forEach(function(t){ t.textContent = d.title; t.href = d.url; });
      card.querySelector('.rbf-m').href = d.url;
      if (d.imgs.length) {
        card.querySelector('.rbf-m').innerHTML = d.imgs.map(function(s){ s = s.replace(/^\/\//, 'https://'); return '<span class="rbf-sl"><img src="' + s + (s.indexOf('?') > 0 ? '&' : '?') + 'width=900" alt="" width="900" height="900"></span>'; }).join('');
        var dots = card.querySelector('.rbf-dots'); if (dots) dots.innerHTML = d.imgs.map(function(_, k){ return '<i' + (k ? '' : ' class="on"') + '></i>'; }).join('');
      }
      var add = card.querySelector('.rbf-add');
      if (add) { add.dataset.vid = d.vid; add.setAttribute('href', '/cart/add?id=' + d.vid + '&quantity=1'); }
      card.querySelectorAll('.rbf-sz a').forEach(function(x){ x.classList.toggle('on', x === a); });
    } catch (err) { location.href = a.href; }
    card.classList.remove('is-loading');
  });
})();

/* puncte clicabile pe card */
document.addEventListener('click', function(e){
  var i = e.target.closest('.rbf-dots i'); if (!i) return;
  var d = i.parentNode, m = d.parentNode.querySelector('.rbf-m');
  m.scrollTo({left: [].indexOf.call(d.children, i) * m.clientWidth});
});

/* produs cu mai multe mărimi: apare o singură dată în fiecare listă */
(function(){
  function dedupe(){
    document.querySelectorAll('.rbf-grid').forEach(function(g){
      var seen = {};
      g.querySelectorAll('.rbf-c[data-g]').forEach(function(c){ if (seen[c.dataset.g]) c.style.display = 'none'; else seen[c.dataset.g] = 1; });
    });
  }
  document.addEventListener('DOMContentLoaded', dedupe); dedupe();
  new MutationObserver(function(){ clearTimeout(window.__rd); window.__rd = setTimeout(dedupe, 60); }).observe(document.documentElement, {childList: true, subtree: true});
})();

/* cod de reducere în coșul lateral (BLACK sau cod influencer) */
document.addEventListener('click', async function(e){
  var chip = e.target.closest('.rdc-chip'), ap = e.target.closest('.rdc-apply'); if (!chip && !ap) return;
  var box = e.target.closest('.rdc-code'), inp = box.querySelector('.rdc-in'), msg = box.querySelector('.rdc-msg');
  if (chip && !chip.dataset.code) { inp.focus(); return; }
  if (chip) inp.value = chip.dataset.code;
  var code = inp.value.trim().toUpperCase(); if (!code) return;
  msg.className = 'rdc-msg'; msg.textContent = 'Se aplică…';
  try {
    var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'), sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {bubbles: true, detail: {sections: sections}}));
    var j = await (await fetch(root + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({discount: code, sections: sections.join(',')})})).json();
    var cart = await (await fetch(root + 'cart.js')).json(), dc = (cart.discount_codes || []).filter(function(d){ return d.code.toUpperCase() === code; })[0];
    if (!dc || !dc.applicable) { msg.className = 'rdc-msg err'; msg.textContent = 'Codul ' + code + ' nu este valid sau nu se aplică acestor produse.'; return; }
    cart.sections = j.sections;
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles: true, detail: {baseEvent: 'line-item:change', cart: cart}}));
  } catch (err) { msg.className = 'rdc-msg err'; msg.textContent = 'Codul nu a putut fi aplicat. Încearcă din nou.'; }
});
document.addEventListener('keydown', function(e){ if (e.key === 'Enter' && e.target.classList && e.target.classList.contains('rdc-in')) { e.preventDefault(); e.target.parentNode.querySelector('.rdc-apply').click(); } });

/* preț campanie pe pagina produsului: se actualizează la schimbarea mărimii */
document.addEventListener('variant:change', function(e){
  var v = e.detail && e.detail.variant, b = document.querySelector('.rp-bf'); if (!v || !b) return;
  var nat = v.compare_at_price > v.price, np = nat ? v.price : Math.round(v.price * +b.dataset.keep / 100), op = nat ? v.compare_at_price : v.price;
  b.querySelector('.rp-bf-p').textContent = (np / 100).toFixed(2).replace('.', ',') + ' lei';
  var rp = document.querySelector('.product-info .rcx-p'); if (rp) rp.textContent = (Math.round(np * .9) / 100).toFixed(2).replace('.', ',') + ' lei';
  b.querySelector('.rp-bf-pc').textContent = '-' + Math.round(100 - np * 100 / op) + '%';
});

/* bandă cod pe poza produsului */
(function(){ var g = document.querySelector('.product-gallery'), b = document.querySelector('.rcx'); if (!g || !b || g.querySelector('.rcx-strip')) return; var s = document.createElement('span'); s.className = 'rcx-strip'; s.innerHTML = 'BLACK −10% <i>sau</i> COD INFLUENCER −10%'; var m = g.querySelector('.product-gallery__media-list, .product-gallery__carousel') || g; if (getComputedStyle(m).position === 'static') m.style.position = 'relative'; m.appendChild(s); })();
